import React, { Component } from 'react';

import TimeSlotListItem from '../TimeSlotListItem/TimeSlotListItem';

import './TimeSlotList.css';

class TimeSlotList extends Component {
  renderTimeSlotList(timeSlots) {
    if (timeSlots.length > 0) {
      return timeSlots.map(timeSlot => {
        return (
          <TimeSlotListItem
            key={timeSlot.duration + '-' + timeSlot.startDateTime.format()}
            timeSlot={timeSlot}
            onSelectTimeSlot={this.props.onSelectTimeSlot}
            selectedTimeSlot={this.props.selectedTimeSlot}
          />
        );
      });
    }
    return (
      <button className="btn-no-availability btn btn-primary disabled py-3 px-4" type="button">
        No Availability
      </button>
    );
  }

  render() {
    return (
      <div className="TimeSlotList col-12 col-sm-4 text-center mb-3 mb-sm-0">
        <h4 className="mt-sm-3"> {this.props.title} </h4>

        <div
          className="btn-group-vertical btn-group-sm"
          role="group"
          aria-label="available timeslots"
        >
          {this.renderTimeSlotList(this.props.timeSlots)}
        </div>
      </div>
    );
  }
}

export default TimeSlotList;



// WEBPACK FOOTER //
// ./src/components/TimeSlotList/TimeSlotList.js